// extracted by mini-css-extract-plugin
export var avatarContainer = "_e3-0";
export var avatarTypingWave = "_e3-i";
export var gray = "_e3-f";
export var green = "_e3-c";
export var icon = "_e3-9";
export var image = "_e3-1";
export var lg = "_e3-6";
export var md = "_e3-5";
export var presenceDot = "_e3-b";
export var red = "_e3-d";
export var sm = "_e3-4";
export var status = "_e3-a";
export var typingDot = "_e3-h";
export var typingPill = "_e3-g";
export var xl = "_e3-7";
export var xs = "_e3-3";
export var xxl = "_e3-8";
export var xxs = "_e3-2";
export var yellow = "_e3-e";